import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.exit.committee');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-exit-committee',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.exit.committee/view.scss */
:host {
  display: block;
}`],
})
export class PageExitCommitteeComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public token: string = '';
    public loading: boolean = true;
    public saving: boolean = false;
    public saved: boolean = false;
    public error: string = '';

    public company: any = null;
    public meetingDate: string = '';
    public location: string = '';
    public member: any = null;
    public documents: any[] = [];
    public reviewData: any = {};

    public async ngOnInit() {
        await this.service.init();
        await this.service.loading.hide();
        this.token = WizRoute.segment.token || '';
        if (!this.token) {
            this.error = '유효하지 않은 링크입니다.';
            this.loading = false;
            await this.service.render();
            return;
        }
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call('verify', { token: this.token });
        if (code !== 200) {
            this.error = data?.message || '회수심의 정보를 확인할 수 없습니다.';
            this.loading = false;
            await this.service.render();
            return;
        }
        this.applyData(data.data);
        this.loading = false;
        await this.service.render();
    }

    private applyData(data: any) {
        this.company = data.company;
        this.meetingDate = data.meeting_date || '';
        this.location = data.location || '';
        this.member = data.member || {};
        this.documents = data.documents || [];
        this.reviewData = data.review_data || {};
    }

    public payload() {
        return {
            decision: this.member.decision || 'pending',
            opinion: this.member.opinion || '',
        };
    }

    public async submit() {
        if (!this.member) return;
        if (!this.member.decision || this.member.decision === 'pending') {
            this.service.alert.error('승인 여부를 선택하세요.');
            return;
        }
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('submit', {
            token: this.token,
            data: JSON.stringify(this.payload())
        });
        this.saving = false;
        if (code !== 200) {
            this.service.alert.error(data?.message || '저장에 실패했습니다.');
            await this.service.render();
            return;
        }
        this.applyData(data.data);
        this.saved = true;
        this.service.alert.success('저장되었습니다.');
        await this.service.render();
    }

    public formatAmount(value: any): string {
        const amount = Number(value || 0);
        if (!amount) return '-';
        if (Math.abs(amount) >= 100000000) return (amount / 100000000).toFixed(1) + '억원';
        return Math.round(amount).toLocaleString() + '원';
    }
}

export default PageExitCommitteeComponent;